import {Severity, FeedbackManager} from '@mojility/coach-core';

const PasswordResetRequestController = function ($scope, $location, localize, eventsService, accountGateway) {
  const $ctrl = this;

  // onInit
  $ctrl.localize = localize;
  $ctrl.email = '';
  $ctrl.labels = {
    ready: $ctrl.localize.string('password_reset','send_request'),
    busy: $ctrl.localize.string('password_reset','in_progress'),
    fail: 'Unable to request a password reset.'
  };
  $ctrl.feedbackManager = new FeedbackManager(document.getElementById('password-reset-request'), $ctrl.labels);

  $ctrl.requestResetEmail = function () {
    $ctrl.feedbackManager.start();
    accountGateway.requestPasswordReset($ctrl.email)
      .then(() => {
        $scope.$applyAsync(() => {
          eventsService.publishSystemMessage($ctrl.localize.string('password_reset','complete'));
          $location.path('/');
        });
      })
      .catch(error => {
        $ctrl.feedbackManager.failWithMessage(error.message);
        if (error.severity === Severity.ERROR)
          eventsService.publishSystemError(error.message);
        else
          eventsService.publishSystemMessage(error.message);
        $scope.$digest();
      });

  };

  $ctrl.submitIsDisabled = function () {
    return !$ctrl.email
  };
};

export default {
  name: 'PasswordResetRequestController',
  fn: PasswordResetRequestController
};